import { useNavigate } from "react-router-dom";
import Breadcrumb from "@/components/base/Breadcrumb";
import ConfigAgentEditor from "./ConfigAgentEditor";

export default function ConfigAgentCreatePage() {
  const navigate = useNavigate();
  return <div className="space-y-5">
    <Breadcrumb items={[{ label: "管理后台", href: "/forex/overview" }, { label: "智能体运营", href: "/forex/agents" }, { label: "创建智能体" }]} />
    <div className="flex items-start justify-between gap-4 flex-wrap"><div className="flex items-start gap-3">
      <div className="w-10 h-10 rounded-xl bg-brand/10 text-brand flex items-center justify-center shrink-0"><i className="ri-robot-2-line text-xl" /></div>
      <div><h2 className="text-lg font-semibold text-text-primary">创建决策智能体</h2>
        <p className="mt-1 text-xs text-text-muted">选择已接入的平台账号和完整策略版本；点击“创建并开始验证”后启动审核前验证，审核通过后正式上线。</p></div></div>
      <button type="button" onClick={() => navigate("/forex/agents")} className="inline-flex items-center gap-1.5 px-3 py-2 rounded-lg bg-white border border-surface-border text-xs font-medium text-text-secondary"><i className="ri-arrow-left-line text-sm" />返回智能体列表</button></div>
    <div className="rounded-xl border border-blue-500/20 bg-blue-500/5 px-4 py-3 flex items-center justify-between gap-3 flex-wrap">
      <p className="text-xs text-blue-700">策略、账户风控和 AI 指令保存在同一策略版本。</p>
      <button type="button" onClick={() => navigate("/forex/strategy-templates")} className="text-xs font-medium text-blue-700 hover:underline">管理策略模板</button></div>
    <ConfigAgentEditor onDone={() => navigate("/forex/agents")} />
  </div>;
}
